<template>
   <div>
       <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>
      <b-card style="margin: 20px">
      <b-card-header  header-tag="header" class="p-1" role="tab">
            Mi Préstamo
      </b-card-header>
      <b-card-body sub-title="">
                <div class="row  form-group" width="40px"  style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0">
                        <div class="col-md-12" style="text-align: center;">
                                 <img src="@/assets/loan_no_ok.png" width="80px" />
                       </div>
                       <div class="col-md-12 h4" style="text-align: center;color:red"> 
                           Lamentablemente no podrás solicitar tu préstamo 
                       </div>
                </div>
                <div class="col-md-12" style="text-align:center">
                        <button class="btn btn-success" v-on:click="aceptar"> Aceptar</button>
                </div>
    </b-card-body>
    </b-card> 
  </div>
</template>

<style>

</style>

<script>

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

export default {
     name: "miprestamorechazado",
   props: {
  },
  
  data() {
    return {
      model: {
      },
    };
  },
  methods:{
       aceptar:function(){
         let context = this;
         context.$router.push("/Dashboard");
        },
  },
}
</script>